import NiceModal, { useModal } from '@ebay/nice-modal-react';

import { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import LottiePlayer from 'components/global/LottiePlayer';
import Modal from 'components/global/Modal';
import * as S from 'components/global/styled/ConfirmationModal.styled';

import useAlert from 'hooks/useAlert';
import useAxiosPrivate from 'hooks/useAxiosPrivate';

import { ORDER_ACTIONS } from 'services/consts';

import AppLogger from 'utils/AppLogger';

const CancelShipmentConfirmationModal = NiceModal.create(({ otoOrderIDs, yesAction }) => {
	const { t } = useTranslation();
	const modal = useModal();
	const axiosPrivate = useAxiosPrivate();
	const { showError } = useAlert();
	const [cancellationMessageData, setCancellationMessageData] = useState([]);

	const handleCloseModal = () => {
		modal.remove();
	};

	useEffect(() => {
		const getCancelShipmentConfirmation = async () => {
			try {
				const response = await axiosPrivate.post(ORDER_ACTIONS.CANCEL_SHIPMENT_CONFIRMATION_MESSAGE, {
					otoOrderIDs
				});
				if (response.status === 200) {
					response.data.forEach(({ otoOrderId, deliveryCompanyName, creditRefundPeriod }) => {
						setCancellationMessageData((prev) => {
							const isDeliveryCompanyNameExist = prev?.some(
								(item) => item.deliveryCompanyName === deliveryCompanyName
							);
							if (isDeliveryCompanyNameExist) return prev;
							return [
								...prev,
								{
									otoOrderId,
									deliveryCompanyName,
									creditRefundPeriod
								}
							];
						});
					});
				} else {
					AppLogger.error(response);
				}
			} catch (error) {
				showError();
				AppLogger.error(error);
			}
		};

		getCancelShipmentConfirmation();
	}, [otoOrderIDs]);

	return (
		<Modal maxWidth="x-small" fullwidth className="modal-confirmation">
			<S.Container>
				<S.IconContainer>
					<LottiePlayer name={'confirmation-modal'} />
				</S.IconContainer>
				<S.HeadText>{t('cancelShipmentTitle')}</S.HeadText>
				<S.BodyText>
					{cancellationMessageData && cancellationMessageData.length > 0
						? cancellationMessageData.map((cancellationMessage) => (
								<div key={cancellationMessage.otoOrderId}>
									<Trans
										i18nKey="cancelShipmentConfirmationWithDeliveryCompanyAndCreditRefundPeriod"
										values={{
											deliveryCompanyName: cancellationMessage.deliveryCompanyName,
											creditRefundPeriod: cancellationMessage.creditRefundPeriod
										}}
									/>
								</div>
							))
						: t('cancelShipmentConfirmationText')}
				</S.BodyText>

				<S.BlockDiv>
					<S.ButtonContainer>
						<S.SmallButton
							onClick={() => {
								handleCloseModal();
							}}
							label={'no'}
							variant="outline"
						/>
					</S.ButtonContainer>
					<S.ButtonContainer>
						<S.SmallButton
							onClick={() => {
								handleCloseModal();
								yesAction && yesAction();
							}}
							variant="blue"
							label={'yes'}
						/>
					</S.ButtonContainer>
				</S.BlockDiv>
			</S.Container>
		</Modal>
	);
});

export default CancelShipmentConfirmationModal;
